import gql from 'graphql-tag';
import { editorBlockFragment } from '@/editor/api/graphql/editor-block.fragment';

export const documentPageQuery = gql`
  query DocumentPages($documentId: String!) {
    document(documentId: $documentId) {
      id
      pages {
        id
        thumbUrl
        pageType
        pageNum
        pageHeight
        pageWidth
        cropBoxH
        cropBoxW
        video {
          id
          thumbUrl
          videoUrl
          status
        }
        contentLinkBlock {
          buttonText
          description
          id
          thumbUrl
          thumbExtension
          title
          url
        }
        editorBlock {
          ...editorBlockFragment
        }
      }
    }
  }
  ${editorBlockFragment}
`;

export const documentAttachments = gql`
  query DocumentAttachments($documentId: String!) {
    document(documentId: $documentId) {
      id
      documentAttachments {
        id
        restrictAccess
        requireView
        createdAt
        previewUrl
        attachment {
          attachmentType
          attachmentTitle
          attachmentDescription
          attachmentUrl
          attachmentFilename
          attachmentSize
          attachmentSha
          thumbUrl
          published
          library
          hashId
        }
        accessRecipientList {
          id
          firstName
          lastName
          fullName
          roleName
        }
      }
    }
  }
`;

export const recipientsQuery = gql`
  query DocumentRecipients($documentId: String!) {
    document(documentId: $documentId) {
      id
      recipients {
        firstName
        lastName
        fullName
        companyName
        companyNumber
        title
        mobile
        email
        thumbUrl
        gender
        role
        roleName
        id
        orderNum
        verifyQna
        verifyQnaOpen
        verifyQnaSign
        verifyQnaQuestion
        verifyQnaAnswer
        verifySms
        verifySmsOpen
        verifySmsSign
        verifyLinkedin
        verifyEid
        verifyEidType
        createdAt
        phone
        note
      }
    }
  }
`;
